'use client'

import { Button } from '@/components/ui/button'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { CareAndShareContainer } from './container'

export const CareShareGallery = () => {
  const t = useTranslations()

  const galleryItems = [
    '/image/February2023/mceclip0_15.jpg',
    '/image/February2023/mceclip12_7.jpg',
    '/image/February2023/mceclip0_33.png',
    '/image/February2023/mceclip4_82.jpg',
  ]

  return (
    <>
      <CareAndShareContainer>
        <h2 className='mb-4 text-center font-criteria text-lg font-medium uppercase leading-6 text-neutral-900 lg:text-2xl lg:leading-9'>
          {t('care_and_share_hardcode.gallery.title')}
        </h2>

        <Carousel
          opts={{
            align: 'start',
            duration: 50,
            slidesToScroll: 2,
            loop: true,
          }}
          className='mt-4 w-full'
        >
          <CarouselContent className='-pl-2'>
            {galleryItems.map((item) => (
              <CarouselItem
                key={item}
                className='basis-1/2 pl-2 first-of-type:pl-4 lg:basis-1/3 lg:pl-6'
              >
                <Image
                  src={ImageHelper.getImageUrl(item)}
                  alt={item}
                  width={412}
                  height={313}
                  className='w-full rounded-2xl object-cover max-lg:h-[152px] lg:h-full lg:w-full'
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselNavigation />
        </Carousel>
      </CareAndShareContainer>

      <CareAndShareContainer className='pt-5'>
        <h3 className='mb-4 text-center font-criteria text-base font-medium uppercase leading-6 text-neutral-900 lg:text-2xl lg:leading-9'>
          {t('care_and_share_hardcode.gallery.follow_us.title')}
        </h3>

        <div className='flex flex-col items-center justify-center gap-2 lg:flex-row'>
          <Button
            size={'large'}
            className='rounded-xl px-4 py-2 text-xs normal-case leading-3.5 lg:h-[54px] lg:text-base lg:font-medium lg:leading-6'
            asChild
          >
            <Link
              href={'https://www.facebook.com/caresharewithcoolmate'}
              target='_blank'
              rel='noreferrer noopener'
            >
              <svg
                width='28'
                height='29'
                viewBox='0 0 28 29'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='lg:!h-8 lg:!w-8'
              >
                <circle cx='14' cy='14.8604' r='13.5' stroke='white' />
                <path
                  d='M15.1931 22.8604V15.5625H17.5508L17.9046 12.7176H15.1931V10.9015C15.1931 10.0781 15.4124 9.51696 16.5506 9.51696L18 9.51634V6.97174C17.7494 6.93791 16.889 6.86035 15.8876 6.86035C13.7965 6.86035 12.3649 8.18592 12.3649 10.6198V12.7176H10V15.5625H12.3649V22.8604H15.1931Z'
                  fill='white'
                />
              </svg>
              {t('care_and_share_hardcode.gallery.follow_us.facebook_button')}
            </Link>
          </Button>

          <Button
            size={'large'}
            variant={'black'}
            className='rounded-xl px-4 py-2 text-xs normal-case leading-3.5 lg:h-[54px] lg:text-base lg:font-medium lg:leading-6'
            asChild
          >
            <Link
              href={'https://www.tiktok.com/@cool.coolmate'}
              target='_blank'
              rel='noreferrer noopener'
            >
              <svg
                width='29'
                height='29'
                viewBox='0 0 29 29'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                className='lg:!h-8 lg:!w-8'
              >
                <circle cx='14.5' cy='14.8604' r='13.5' stroke='white' />
                <path
                  d='M21.4925 10.8665C20.5817 10.8665 19.7413 10.5636 19.0665 10.0525C18.2925 9.46656 17.7364 8.60711 17.54 7.61652C17.4914 7.37177 17.4652 7.11919 17.4627 6.86035H14.8609V13.9989L14.8578 17.909C14.8578 18.9543 14.1798 19.8407 13.24 20.1524C12.9673 20.2429 12.6727 20.2858 12.366 20.2689C11.9745 20.2473 11.6076 20.1286 11.2887 19.9371C10.6101 19.5296 10.1501 18.7903 10.1376 17.9446C10.118 16.6229 11.1821 15.5453 12.4975 15.5453C12.7572 15.5453 13.0065 15.5879 13.24 15.6652V13.7141V13.0127C12.9938 12.976 12.7432 12.9569 12.4897 12.9569C11.05 12.9569 9.70338 13.5579 8.74082 14.6405C8.0133 15.4586 7.57691 16.5024 7.50958 17.5969C7.42137 19.0348 7.94535 20.4016 8.96151 21.41C9.11082 21.558 9.26761 21.6954 9.43157 21.8222C10.3028 22.4954 11.3679 22.8604 12.4897 22.8604C12.7432 22.8604 12.9938 22.8416 13.24 22.805C14.288 22.6491 15.2549 22.1674 16.018 21.41C16.9556 20.4795 17.4736 19.2441 17.4792 17.9293L17.4658 12.0903C17.9131 12.4368 18.4022 12.7235 18.9271 12.946C19.7435 13.2918 20.6091 13.4671 21.5 13.4668V11.5698V10.8659C21.5006 10.8665 21.4931 10.8665 21.4925 10.8665Z'
                  fill='white'
                />
              </svg>
              {t('care_and_share_hardcode.gallery.follow_us.tiktok_button')}
            </Link>
          </Button>
        </div>
      </CareAndShareContainer>
    </>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
